export const EFFECT_SEVERITY = Object.freeze({
  removes_remedy: 'high',
  caps_liability: 'high',
  adds_obligation: 'medium',
  shifts_cost: 'medium',
  narrows_right: 'medium',
  extends_deadline: 'low',
  // A change in the owner's favour. Low, because severity asks how much
  // attention this needs — but "little" is not "none", which is what it got
  // while `administrative` was the only label a favourable change could take.
  // Kept in step with EFFECT_SEVERITY in counterparty_classification.rb.
  benefits_owner: 'low',
  administrative: 'low',
});

const SEVERITY_RANK = Object.freeze({ low: 0, medium: 1, high: 2 });

export function normalizeCounterpartyEffects(rawEffects) {
  const effects = Array.isArray(rawEffects) ? rawEffects : [];

  return [...new Set(effects)].filter(effect =>
    Object.prototype.hasOwnProperty.call(EFFECT_SEVERITY, effect),
  );
}

/**
 * Severity is a deterministic consequence of the validated effects. A missing
 * effect produces no severity rather than turning malformed output into a
 * reassuring low-severity change.
 */
export function deriveCounterpartySeverity(rawEffects) {
  const effects = normalizeCounterpartyEffects(rawEffects);
  if (effects.length === 0) return null;

  return effects.reduce((highest, effect) => {
    const severity = EFFECT_SEVERITY[effect];
    return SEVERITY_RANK[severity] > SEVERITY_RANK[highest]
      ? severity
      : highest;
  }, 'low');
}

/**
 * Validate the model's effect ids and overwrite any model-supplied severity.
 * P2-02 uses this on the combined enrichment response; it does not make a
 * separate request.
 */
export function validateCounterpartyEffects(entries) {
  return (Array.isArray(entries) ? entries : []).map(entry => {
    const effects = normalizeCounterpartyEffects(entry && entry.effects);

    return {
      ...entry,
      effects,
      severity: deriveCounterpartySeverity(effects),
    };
  });
}
